module.exports = __webpack_public_path__ + "static/media/levain_bg_img_5.ea2af6d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/levain_bg_img_5.jpg
// module id = 1060
// module chunks = 0